import { Button, Grid, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import pendingBanner from "../../../../assets/payment_pending_banner.svg"
import { SignupRoute, SignupRouteParams } from "../../../../views/signup-flow/SignupFlow/SignupFlow"
import PaymentAcknowledgementBanner from "../../PaymentAcknowledgementBanner"

const PaymentPendingPage = (props: SignupRouteParams) => {
    const { orderId, onNavigateTo } = props
    const { t } = useTranslation(`acknowledgement`)

    const handleHomeClick = () => {
        if (window.myNtucConfig.signupBackToHomeHomeUrl != undefined) {
            window.location.replace(window.myNtucConfig.signupBackToHomeHomeUrl)
        } else {
            onNavigateTo(SignupRoute.Disclaimer)
        }
    }

    return (
        <Grid rowSpacing={2} mt={{ xs: 0, md: -2 }} padding={2} container justifyContent="center">
            <PaymentAcknowledgementBanner bannerUrl={pendingBanner} alt="Payment pending banner" />
            <Grid container item justifyContent="center" xs={12}>
                <Typography textAlign="center" variant="h2">{t(`pending.title`)}</Typography>
            </Grid>
            <Grid item justifyContent="center" xs={12}>
                <Typography textAlign="center">{t(`pending.body`)}</Typography>
            </Grid>
            <Grid item justifyContent="center" xs={12}>
                <Typography color="text.secondary" textAlign="center">{t(`pending.reference`)}</Typography>
                <Typography textAlign="center">{orderId}</Typography>
            </Grid>
            <Grid container item xs={12} justifyContent="center" alignItems="center" columnSpacing={2} rowSpacing={3}>
                <Grid item xs={12} md={3} textAlign="center">
                    <Button onClick={handleHomeClick} variant="contained" color="primary" size="large" >
                        {t(`buttons.home`)}
                    </Button>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default PaymentPendingPage